const FindFileFormat = (fileName, allTypes) => {
  let affix = fileName?.split('.')?.[1];
  let type = allTypes?.filter((x) => x.name == affix)?.[0]?.mimeType;
  //   if (affix == 'rar') {
  //     type = 'application/x-rar-compressed ';
  //   } else {
  //     type = '';
  //   }
  console.log('typeeeee==', fileName, affix, type);
  return type;
};
export default FindFileFormat;
